import { Box, Text } from '@factorialco/deprecated-design-system'

import type { SalaryByWorkplaceGroup } from 'modules/job_catalog/lib/salaryUtils'

interface SalariesCardProps {
  groupedSalaries: SalaryByWorkplaceGroup[]
}

const SalariesCard = ({ groupedSalaries }: SalariesCardProps) => {
  return (
    <Box
      border={{ all: { width: 's1', style: 'solid', color: 'grey200' } }}
      borderRadius={{ all: 'abs016' }}
      style={{ overflow: 'hidden' }}
    >
      {groupedSalaries.map(({ workplaceLabel, formattedRange, frequencyText }, index) => (
        <Box
          key={`${workplaceLabel}-${index}`}
          flexDirection="row"
          alignItems="center"
          justifyContent="spaceBetween"
          paddingTop="s16"
          paddingRight="s16"
          paddingBottom="s16"
          paddingLeft="s16"
          border={
            index === groupedSalaries.length - 1
              ? undefined
              : { bottom: { width: 's1', style: 'solid', color: 'grey200' } }
          }
        >
          <Text.Normal size="200" color="grey800" weight="medium">
            {workplaceLabel}
          </Text.Normal>
          <Box flexDirection="row" alignItems="baseline" gap="s4" style={{ whiteSpace: 'nowrap' }}>
            <Text.Normal size="200" color="grey1000" weight="medium">
              {formattedRange}
            </Text.Normal>
            <Text.Normal size="100" color="grey600">
              {frequencyText}
            </Text.Normal>
          </Box>
        </Box>
      ))}
    </Box>
  )
}

export default SalariesCard
